/******************************************************************************************
 *	Pulldown Directive
 ******************************************************************************************/
(function() {
  

  angular.module('rcDirectives.Pulldown', []).directive(
    'rcPulldown',
    /* @ngInject */
    function() {
      return {
        restrict: 'A',
        link: function(scope, element, attrs) {
          var popover = angular.element(element[0].querySelector('.js-pulldown-popover'));

          //Add component classes
          element.addClass('pulldown');
          popover.addClass('pulldown-popover');

          var arrowPosition = attrs.rcPulldownArrow;
          if (arrowPosition) {
            popover.addClass('arrow arrow-' + arrowPosition);
          }

          //Holds popover visibility state
          var visible = false;
          var showPopover = function() {
            visible = true;
            popover.addClass('visible');
          };
          var hidePopover = function() {
            popover.removeClass('visible');
            visible = false;
          };

          //Hides popover and removes the click handler from the `document` object
          var removePopover = function() {
            hidePopover();
            document.removeEventListener('click', documentClickHandler, false);
          };

          //Hide popover if click occurs outside element.
          //Because clicking inside will stopImmediatePropagation(), there's no need to check if event.target is a child of parent pulldown element
          var documentClickHandler = function() {
            if (visible) {
              removePopover();
            }
          };

          //Pulldown element click handler
          element[0].addEventListener(
            'click',
            function(event) {
              event.stopPropagation(); //Prevents event reaching document and hiding popover immediately

              if (!visible) {
                //Show if not visible
                showPopover();
                //Start listening for click events on document to know when to hide the popover
                document.addEventListener('click', documentClickHandler, false);
              } else {
                //If visible...
                //... and click occured on an element with the `rc-pulldown-close` attribute present, remove the popover.
                if (event.target.hasAttribute('rc-pulldown-close')) {
                  removePopover();
                }
              }
            },
            false
          );

          //Clean-up
          scope.$on('$destroy', function() {
            document.removeEventListener('click', documentClickHandler, false);
          });
        }
      };
    }
  );
})();
